gsap.set('.scroll-top', {
    y: 60,
    opacity: 0
})

const st = gsap.timeline({
    scrollTrigger: {
        start: 'top+=300',
        end: '+=1',
        toggleActions: 'play none none reverse',
        scrub: 2,
        // markers: true,
    }
})

st.to('.scroll-top', {
    y: 0,
    opacity: 1,
})

const scrollTop = document.querySelector(".scroll-top");
scrollTop.addEventListener('click', function () {
    lenis.scrollTo('top', {
        duration: 6,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
    })
})